<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable>
              <el-option v-for="item in companyLists" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.START_END" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="onSubmit" :loading="loadSearch">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain class="btn" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px; font-weight: 700">
      <label>销售总量：{{ this.salesStatistics.TOTAL_COUNT }}</label>
      <label style="margin-left: 20px">销售总金额：{{ this.salesStatistics.TOTAL_FEE }}</label>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" max-height="520">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
          <el-table-column prop="CATLOG_NAME" label="产品分类"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="BRAND" label="品牌"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="采购数量"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="采购金额"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
      :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div> -->
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      // loading: false,
      loadSearch: false,
      projects: [],
      searchForm: {
        START_END: [new Date(), new Date()],
      },
      salesStatistics: [],
      tableData: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      companyLists: [],
      currentOrderFlag: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.HISTORY_OUT_DATA_CONDITION.CONDITION) {
      this.searchForm = this.HISTORY_OUT_DATA_CONDITION.CONDITION;
      this.currentPage = this.HISTORY_OUT_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryPro();
  },
  computed: {
    HISTORY_OUT_DATA_CONDITION() {
      return this.$store.state.HISTORY_OUT_DATA_CONDITION;
    },
  },
  methods: {
    // 拉取客户公司和项目点
    queryPro() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 3,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.companyLists = result[0].company;
          this.projects = result[0].project;
        } else {
          this.totalCount = 0;
          this.companyLists = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportData() {
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 20,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.START_END) {
        params.START_DAY = date(this.searchForm.START_END[0], '%F');
        params.END_DAY = date(this.searchForm.START_END[1], '%F');
      }
      if (this.searchForm.START_END == '') {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      } if (this.searchForm.START_END == null) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -----------------------------拉取数据
    queryData() {
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 19,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.START_END) {
        params.START_DAY = date(this.searchForm.START_END[0], '%F');
        params.END_DAY = date(this.searchForm.START_END[1], '%F');
      }
      if (this.searchForm.START_END == '') {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      } if (this.searchForm.START_END == null) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.tableData = result[0].DATA_LIST;
          this.salesStatistics = result[1];
          this.$store.dispatch('SET_HISTORY_OUT_DATA_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.totalCount,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------筛选
    onSubmit() {
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/singleSalesSummary.vue